<template>
  <div
    class="fc-assignment-viz elevation-3 grey lighten-4"
    v-if="
      personAssignments.length > 0 &&
      (formValues.writingDueDate || formValues.editingDueDate)
    "
  >
    <div
      v-for="(person, i) in personAssignments"
      :key="`bar-${i}`"
      :class="`fc-assignment-viz__row ${getGroupSpacing(i)}`"
      class="flex-wrap"
    >
      <div
        class="subtitle-1 text-center"
        :style="{
          position: 'relative',
          width: '100%',
        }"
        @mouseenter="() => handleMouseOverName(person.person)"
        @mouseleave="() => handleMouseOverName(null)"
      >
        {{ person.person }}
        <h3 v-if="!wordCountValidated && !backstageCopywriting">
          Add Word Count
        </h3>
        <div
          class="tooltip tooltip-name-hover"
          :style="{
            display: getTooltimeNameDisplay(person.person),
          }"
        >
          <div v-if="personWordCounts && personWordCounts.length === 0">
            No upcoming assignments
          </div>
          <div
            class="d-flex font-weight-bold"
            v-if="personWordCounts && personWordCounts.length > 0"
          >
            <div class="tooltip-name-hover__block">Due Date</div>
            <div class="tooltip-name-hover__block">Writing Total</div>
            <div class="tooltip-name-hover__block">Editing Total</div>
          </div>
          <div
            v-for="(wc, i) in personWordCounts"
            :style="{
              backgroundColor: i % 2 === 0 ? '#fff' : '#f5f5f5',
            }"
            :key="`wc-row-${i}`"
            class="d-flex"
          >
            <div class="tooltip-name-hover__block">
              {{ wc.date }}
            </div>
            <div class="tooltip-name-hover__block">
              {{ wc.writingTot ? wc.writingTot : "None" }}
            </div>
            <div class="tooltip-name-hover__block">
              {{ wc.editingTot ? wc.editingTot : "None" }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-center" :style="{ width: '15%' }">
        <div
          v-if="
            (formValues.writingDueDate && person.writingWordCount) ||
            (formValues.editingDueDate && person.editingWordCount)
          "
          class="subtitle-2"
        >
          CURRENT
        </div>
        <div
          v-if="formValues.writingDueDate && person.writingWordCount"
          class="d-flex justify-end"
          :style="{ width: '100%', height: '24px' }"
        >
          <div class="subtitle-2"><b>W:</b></div>
          <div
            class="ml-2 subtitle-2 d-flex justify-center"
            :style="{ ...barStyles, width: '50px' }"
          >
            {{ person.writingWordCount }}
          </div>
        </div>
        <div
          v-if="formValues.editingDueDate && person.editingWordCount"
          class="d-flex justify-end"
          :style="{ width: '100%', height: '24px' }"
        >
          <div class="subtitle-2"><b>E:</b></div>
          <div
            class="ml-2 subtitle-2 d-flex justify-center"
            :style="{ ...barStyles, width: '50px' }"
          >
            {{ person.editingWordCount }}
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-center" :style="{ width: '70%' }">
        <div
          v-if="
            (formValues.writingDueDate && person.writingWordCount) ||
            (formValues.editingDueDate && person.editingWordCount)
          "
          class="subtitle-2"
        >
          TOTAL/MAX
        </div>
        <div
          v-if="formValues.writingDueDate && person.writingWordCount"
          class="d-flex"
          :style="{ width: '100%', height: '24px' }"
        >
          <div
            class="bars-col"
            :style="{
              ...barStyles,
            }"
          >
            <div
              class="subtitle-2 d-flex"
              :style="{
                borderRadius: '4px',
                borderRight: '1px solid #c0c0c0',
                width: `${
                  person.writingMaxCapacity > 0
                    ? ((person.writingMaxCapacity -
                        person.writingCapacity +
                        person.writingWordCount) /
                        person.writingMaxCapacity) *
                      100
                    : 100
                }%`,
                background:
                  person.writingCapacity - person.writingWordCount >= 0 &&
                  person.writingMaxCapacity > 0
                    ? 'repeating-linear-gradient(-45deg, rgba(158, 185, 243, 1), rgba(158, 185, 243, 1) 3px, #f5f5f5 3px, #f5f5f5 6px)'
                    : '#ee7975',
                color:
                  person.writingCapacity - person.writingWordCount >= 0 &&
                  person.writingMaxCapacity > 0
                    ? ''
                    : '#fff',
              }"
            >
              <div
                class="d-flex align-center justify-center"
                :style="{
                  width: `${
                    person.writingCapacity - person.writingWordCount >= 0 &&
                    person.writingMaxCapacity > 0
                      ? (person.writingWordCount /
                          (person.writingMaxCapacity -
                            person.writingCapacity +
                            person.writingWordCount)) *
                        100
                      : 100
                  }%`,
                  borderRadius: '4px',
                  borderRight: '1px solid #c0c0c0',
                  background:
                    person.writingCapacity - person.writingWordCount >= 0
                      ? 'rgba(158, 185, 243, 1)'
                      : '#ee7975',
                }"
              >
                <b
                  :style="[
                    (person.writingWordCount / person.writingMaxCapacity) *
                      100 <
                      20 &&
                    person.writingCapacity - person.writingWordCount >= 0
                      ? { position: 'absolute', right: '10px' }
                      : {},
                  ]"
                >
                  {{
                    wordCountValidated
                      ? person.writingMaxCapacity -
                        person.writingCapacity +
                        person.writingWordCount +
                        "/" +
                        person.writingMaxCapacity
                      : "Add Word Count"
                  }}
                </b>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="formValues.editingDueDate && person.editingWordCount"
          class="d-flex"
          :style="{ width: '100%', height: '24px' }"
        >
          <div
            class="bars-col"
            :style="{
              ...barStyles,
            }"
          >
            <div
              class="subtitle-2 d-flex"
              :style="{
                borderRadius: '4px',
                borderRight: '1px solid #c0c0c0',
                width: `${
                  person.editingMaxCapacity > 0
                    ? ((person.editingMaxCapacity -
                        person.editingCapacity +
                        person.editingWordCount) /
                        person.editingMaxCapacity) *
                      100
                    : 100
                }%`,
                background:
                  person.editingCapacity - person.editingWordCount >= 0 &&
                  person.editingMaxCapacity > 0
                    ? 'repeating-linear-gradient(-45deg, rgba(220, 176, 242, 1), rgba(220, 176, 242, 1) 3px, #f5f5f5 3px, #f5f5f5 6px)'
                    : '#ee7975',
                color:
                  person.editingCapacity - person.editingWordCount >= 0 &&
                  person.editingMaxCapacity > 0
                    ? ''
                    : '#fff',
              }"
            >
              <div
                class="d-flex align-center justify-center"
                :style="{
                  width: `${
                    person.editingCapacity - person.editingWordCount >= 0 &&
                    person.editingMaxCapacity > 0
                      ? (person.editingWordCount /
                          (person.editingMaxCapacity -
                            person.editingCapacity +
                            person.editingWordCount)) *
                        100
                      : 100
                  }%`,
                  borderRadius: '4px',
                  borderRight: '1px solid #c0c0c0',
                  background:
                    person.editingCapacity - person.editingWordCount >= 0
                      ? 'rgba(220, 176, 242, 1)'
                      : '#ee7975',
                }"
              >
                <b
                  :style="[
                    (person.editingWordCount / person.editingMaxCapacity) *
                      100 <
                      20 &&
                    person.editingCapacity - person.editingWordCount >= 0
                      ? { position: 'absolute', right: '10px' }
                      : {},
                  ]"
                >
                  {{
                    wordCountValidated
                      ? person.editingMaxCapacity -
                        person.editingCapacity +
                        person.editingWordCount +
                        "/" +
                        person.editingMaxCapacity
                      : "Add Word Count"
                  }}
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-center" :style="{ width: '15%' }">
        <div
          v-if="
            (formValues.writingDueDate && person.writingWordCount) ||
            (formValues.editingDueDate && person.editingWordCount)
          "
          class="subtitle-2"
        >
          LEFT
        </div>
        <div
          v-if="formValues.writingDueDate && person.writingWordCount"
          class="d-flex"
          :style="{ width: '100%', height: '24px' }"
        >
          <div
            class="bars-col subtitle-2 d-flex justify-center"
            :style="{ ...barStyles }"
          >
            {{ person.writingCapacity - person.writingWordCount }}
          </div>
        </div>
        <div
          v-if="formValues.editingDueDate && person.editingWordCount"
          class="d-flex"
          :style="{ width: '100%', height: '24px' }"
        >
          <div
            class="bars-col subtitle-2 d-flex justify-center"
            :style="{ ...barStyles }"
          >
            {{ person.editingCapacity - person.editingWordCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// library
import _ from "lodash";
// internal
import { getStaffAssignmentsByPerson } from "@/utils/fcBotUtils";

export default {
  name: "FCAssignmentVisualization",
  data() {
    return {
      barStyles: {
        width: "100%",
        height: "22px",
        boxSizing: "border-box",
        border: "1px solid #c0c0c0",
        borderRadius: "4px",
      },
      hoveredName: null,
      personWordCounts: null,
    };
  },
  computed: {
    ...mapGetters("fcBot", [
      "staffAssignments",
      "formValues",
      "wordCountValidated",
      "capacityPool",
      "defaultCapacityPool",
      "adjustedCapacityPool",
      "backstageCopywriting",
    ]),
    personAssignments() {
      let assignments = getStaffAssignmentsByPerson(
        this.staffAssignments,
        false
      ).filter((el) => el.person !== "" && el.role !== "reviewer");

      if (_.isEmpty(assignments)) {
        return [];
      } else {
        assignments = assignments.map((el) => {
          return {
            ...el,
            wordCount: this.staffAssignments[el.taskName].wordCount,
          };
        });
        assignments = _.groupBy(assignments, (el) => el.person);
        const retVal = [];
        Object.keys(assignments).forEach((person) => {
          let accumulator = 0,
            writingWordCount = 0,
            editingWordCount = 0,
            writingCapacity,
            editingCapacity,
            writingMaxCapacity,
            editingMaxCapacity;
          const assignmentsAccumulator = [];
          assignments[person].forEach((el) => {
            const r = {
              ...el,
              start: accumulator,
              end: accumulator + el.wordCount,
            };
            accumulator += el.wordCount;
            assignmentsAccumulator.push(r);
            if (el.role === "writer") writingWordCount += el.wordCount;
            if (el.role === "editor") editingWordCount += el.wordCount;
          });
          if (this.formValues.writingDueDate) {
            const adjustedWriting = this.adjustedCapacityPool.find(
              (el) =>
                el.name === person &&
                el.dates.includes(this.formValues.writingDueDate) &&
                el.adjustedWritingWorkload !== null
            );
            const defaultWriting = this.defaultCapacityPool.find(
              (el) => el["Name"] === person
            )["FCLOCAvailability(Translating)"];
            writingMaxCapacity = adjustedWriting
              ? adjustedWriting.adjustedWritingWorkload
              : Number(defaultWriting);
            const writingData = this.capacityPool.find(
              (el) =>
                el["RelatedPerson"] === person &&
                el["DueDate"] ===
                  this.$moment(this.formValues.writingDueDate).format(
                    "MM-DD-YYYY"
                  ) &&
                el["Primary/Reviewer"] === "Primary"
            );
            writingCapacity =
              writingMaxCapacity -
              (!!writingData ? writingData["WordCount(tot)"] : 0);
            this.setStaffAssignmentOverloading({
              taskName: assignments[person][0].taskName,
              geo: assignments[person][0].geo,
              key: "writerOverloaded",
              value: writingCapacity - writingWordCount < 0,
            });
          }

          if (this.formValues.editingDueDate) {
            const adjustedEditing = this.adjustedCapacityPool.find(
              (el) =>
                el.name === person &&
                el.dates.includes(this.formValues.editingDueDate) &&
                el.adjusted$EditingWorkload !== null
            );
            const defaultEditing = this.defaultCapacityPool.find(
              (el) => el["Name"] === person
            )["FCLOCAvailability(Editing)"];
            editingMaxCapacity = adjustedEditing
              ? adjustedEditing.adjustedEditingWorkload
              : Number(defaultEditing);
            const editingData = this.capacityPool.find(
              (el) =>
                el["RelatedPerson"] === person &&
                el["DueDate"] ===
                  this.$moment(this.formValues.editingDueDate).format(
                    "MM-DD-YYYY"
                  ) &&
                el["Primary/Reviewer"] === "Reviewer"
            );
            editingCapacity =
              editingMaxCapacity -
              (!!editingData ? editingData["WordCount(tot)"] : 0);
            this.setStaffAssignmentOverloading({
              taskName: assignments[person][0].taskName,
              geo: assignments[person][0].geo,
              key: "editorOverloaded",
              value: editingCapacity - editingWordCount < 0,
            });
          }

          retVal.push({
            person: person,
            assignments: assignmentsAccumulator,
            totalWordCount: accumulator,
            writingWordCount: writingWordCount,
            editingWordCount: editingWordCount,
            writingCapacity: writingCapacity,
            editingCapacity: editingCapacity,
            writingMaxCapacity: writingMaxCapacity,
            editingMaxCapacity: editingMaxCapacity,
            geo: assignments[person][0].geo, // a bit lazy here, person's geo is the first assignment in their list. Correct in most cases.
          });
        });
        return _.sortBy(retVal, "geo");
      }
    },
  },
  methods: {
    ...mapActions("fcBot", ["setStaffAssignmentOverloading"]),
    getGroupSpacing(index) {
      if (index === 0) {
        return "";
      } else if (
        this.personAssignments[index].geo !==
        this.personAssignments[index - 1].geo
      ) {
        return "group-start-spacing";
      } else {
        return "";
      }
    },
    getTooltimeNameDisplay(person) {
      if (!this.hoveredName) return "none";

      if (person === this.hoveredName) {
        return "block";
      } else {
        return "none";
      }
    },
    getWordCountAndDatesForPerson(person) {
      const filtered = this.capacityPool.filter(
        (el) => el["RelatedPerson"] === person && el["WordCount(tot)"] !== null
      );

      const separated = [];
      filtered.forEach((el) => {
        const obj = { name: el["RelatedPerson"], date: el["DueDate"] };
        if (el["Primary/Reviewer"] === "Primary")
          Object.assign(obj, {
            writingTot: el["WordCount(tot)"],
          });
        if (el["Primary/Reviewer"] === "Reviewer")
          Object.assign(obj, {
            editingTot: el["WordCount(tot)"],
          });
        separated.push(obj);
      });

      const separatedCopy = [...separated];
      const merged = [...separated, ...separatedCopy].reduce(
        (mergedRes, curEl) => {
          let matchingElementIdx = mergedRes.findIndex(
            (el) => el.date === curEl.date
          );
          if (matchingElementIdx !== -1) {
            mergedRes[matchingElementIdx] = {
              ...mergedRes[matchingElementIdx],
              ...curEl,
            };
          } else {
            mergedRes = [...mergedRes, curEl];
          }
          return mergedRes;
        },
        []
      );
      return merged;
    },
    handleMouseOverName(person) {
      if (!person) {
        this.personWordCounts = null;
        this.hoveredName = null;
      }

      if (this.capacityPool && person) {
        this.personWordCounts = this.getWordCountAndDatesForPerson(person);
        this.hoveredName = person;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fc-assignment-viz {
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 30px;
  height: fit-content;

  .tooltip {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);
    width: fit-content;
    background-color: #fff;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px #000;
    z-index: 999;
    pointer-events: none;
    display: none;
  }

  .tooltip-name-hover {
    &__block {
      width: 120px;
    }
  }

  &__row {
    display: flex;
    margin: 0px !important;
    padding: 5px 0px;

    &.group-start-spacing {
      margin-top: 15px !important;
      border-top: 1px solid rgb(106, 106, 106);
    }

    .bars-col {
      flex: 1 1 auto;
      position: relative;
      display: flex;
      margin-left: 10px;

      > div {
        &:only-child {
          > .bar {
            border-radius: 4px !important;
          }
        }

        &:first-child {
          > .bar {
            border-radius: 4px 0px 0px 4px;
          }
        }

        &:last-child {
          > .bar {
            border-radius: 0px 4px 4px 0px;
          }
        }
      }
    }
  }
}
</style>
